export const pipelineOpportunityTypeColors: Record<string, string> = {
  EN: "#C7C7CD",
  NN: "#26A69A",
  EE: "#FFEB3B",
};

export const pipelineByOpportunityChartConfig = {
  height: 400,
  minHeight: 400,
  titleAlign: "left" as const,
};
